import React, { FC } from 'react';
import { useProjectConfigContext } from '../../contexts/ProjectConfigContext';
import { IExtra4Map } from '../../interface/permitRequest.interface';
import { CheckBoxColors } from '../../enums/colors/checkBoxColors.type';
import RadioBtn from '../../components/form/radios/RadioBtn';
import useAddPermitRequestPageApi from '../../axios/useAddPermitRequestPage.api';
import useTags from '../../hooks/useTags';
import checkBoxesForPardesHannaKarkurLang from '../../data/lang/features/checkBoxesForPardesHannaKarkur.lang';
import PermitType from '../../types/permit.type';

type Props = {
  setFieldValue: (field: string, value: any) => void,
  extra4Map: IExtra4Map,
  handleOnChangeStreet: (streetId: string | number) => void,
  sethouseAndAppDes: (value: boolean) => void,
  setStreetDes: (value: boolean) => void,
};

const CheckBoxesForPardesHannaKarkur: FC<Props> = ({
  setFieldValue,
  extra4Map,
  handleOnChangeStreet,
  sethouseAndAppDes,
  setStreetDes
}) => {


  const { projectConfigState, setStreets } = useProjectConfigContext();
  const { getStreetsApi } = useAddPermitRequestPageApi();

  const projectId = projectConfigState.projectId;

  const generateTag = useTags();

  const cityResidentLabel = generateTag(checkBoxesForPardesHannaKarkurLang, 'cityResidentLabel');
  const municipalParkingLabel = generateTag(checkBoxesForPardesHannaKarkurLang, 'municipalParkingLabel');
  const agriculturalSchoolFacultyLabel = generateTag(checkBoxesForPardesHannaKarkurLang, 'agriculturalSchoolFacultyLabel');
  const collectionOrWaterDepartmentLabel = generateTag(checkBoxesForPardesHannaKarkurLang, 'collectionOrWaterDepartmentLabel');
  const planningAndConstructionCommitteeLabel = generateTag(checkBoxesForPardesHannaKarkurLang, 'planningAndConstructionCommitteeLabel');
  const kindergartenElaAndAgosLabel = generateTag(checkBoxesForPardesHannaKarkurLang, 'kindergartenElaAndAgosLabel');

  if (projectId !== 18 && projectId !== 1) {
    return null;
  }

  return (
    <div className='row'>
      {extra4Map.isCityResident ? (
        <div className="col-12 mt-1 mb-2">
          <RadioBtn
            isChecked={extra4Map.isCityResident === '1'}
            label={cityResidentLabel}
            value={extra4Map.isCityResident}
            onClick={(e: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
              handleOnChange('isCityResident', e);
            }}
            id="isCityResidentId"
            name='isCityResident'
            color={CheckBoxColors.SUCCESS}
          />
        </div>
      ) : ''}

      {extra4Map.needParkingInMunicipalPardesHannaKarkur ? (
        <div className="col-12">
          <RadioBtn
            isChecked={extra4Map.needParkingInMunicipalPardesHannaKarkur === '1'}
            label={municipalParkingLabel}
            value={extra4Map.needParkingInMunicipalPardesHannaKarkur}
            onClick={(e: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
              handleOnChange('needParkingInMunicipalPardesHannaKarkur', e);
            }}
            id="needParkingInMunicipalPardesHannaKarkurId"
            name='needParkingInMunicipalPardesHannaKarkur'
            color={CheckBoxColors.SUCCESS}
          />
        </div>
      ) : ''}

      {extra4Map.agriculturalSchoolFaculty ? (
        <div className="col-12">
          <RadioBtn
            isChecked={extra4Map.agriculturalSchoolFaculty === '1'}
            label={agriculturalSchoolFacultyLabel}
            value={extra4Map.agriculturalSchoolFaculty}
            onClick={(e: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
              handleOnChange('agriculturalSchoolFaculty', e);
            }}
            id="agriculturalSchoolFacultyId"
            name='agriculturalSchoolFaculty'
            color={CheckBoxColors.SUCCESS}
          />
        </div>
      ) : ''}

      {extra4Map.collectionOrWaterDepartmentEmployees ? (
        <div className="col-12">
          <RadioBtn
            isChecked={extra4Map.collectionOrWaterDepartmentEmployees === '1'}
            label={collectionOrWaterDepartmentLabel}
            value={extra4Map.collectionOrWaterDepartmentEmployees}
            onClick={(e: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
              handleOnChange('collectionOrWaterDepartmentEmployees', e);
            }}
            id="collectionOrWaterDepartmentEmployeesId"
            name='collectionOrWaterDepartmentEmployees'
            color={CheckBoxColors.SUCCESS}
          />
        </div>
      ) : ''}

      {extra4Map.planningAndConstructionCommitteeEmployees ? (
        <div className="col-12">
          <RadioBtn
            isChecked={extra4Map.planningAndConstructionCommitteeEmployees === '1'}
            label={planningAndConstructionCommitteeLabel}
            value={extra4Map.planningAndConstructionCommitteeEmployees}
            onClick={(e: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
              handleOnChange('planningAndConstructionCommitteeEmployees', e);
            }}
            id="planningAndConstructionCommitteeEmployeesId"
            name='planningAndConstructionCommitteeEmployees'
            color={CheckBoxColors.SUCCESS}
          />
        </div>
      ) : ''}

      {extra4Map.kindergartenElaAndAgosEmployees ? (
        <div className="col-12">
          <RadioBtn
            isChecked={extra4Map.kindergartenElaAndAgosEmployees === '1'}
            label={kindergartenElaAndAgosLabel}
            value={extra4Map.kindergartenElaAndAgosEmployees}
            onClick={(e: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
              handleOnChange('kindergartenElaAndAgosEmployees', e);
            }}
            id="kindergartenElaAndAgosEmployeesId"
            name='kindergartenElaAndAgosEmployees'
            color={CheckBoxColors.SUCCESS}
          />
        </div>
      ) : ''}
    </div>
  );

  function handleOnChange(name: string, e: React.MouseEvent<HTMLInputElement, MouseEvent>) {
    handleExtra4MapChange(name, e.currentTarget.value === '1' ? '0' : '1');
  }

  async function handleExtra4MapChange(name: string, value: string) {

    const newExtra4: IExtra4Map = { ...extra4Map, [name]: value };


    let isCityResident = newExtra4.isCityResident;
    let needParkingInMunicipalPardesHannaKarkur = newExtra4.needParkingInMunicipalPardesHannaKarkur;
    let agriculturalSchoolFaculty = newExtra4.agriculturalSchoolFaculty;
    let collectionOrWaterDepartmentEmployees = newExtra4.collectionOrWaterDepartmentEmployees;
    let kindergartenElaAndAgosEmployees = newExtra4.kindergartenElaAndAgosEmployees;
    let planningAndConstructionCommitteeEmployees = newExtra4.planningAndConstructionCommitteeEmployees;
    let streetId = '-1';

    // Update the permit type
    const permitType = determinePermitType(newExtra4);

    if (isCityResident === '0') {

      if (needParkingInMunicipalPardesHannaKarkur == '0'
        && agriculturalSchoolFaculty === '0'
        && collectionOrWaterDepartmentEmployees === '0'
        && kindergartenElaAndAgosEmployees === '0'
        && planningAndConstructionCommitteeEmployees === '0') {

        streetId = '9002';
        newExtra4['needParkingInMunicipalPardesHannaKarkur'] = '1';
      }
    }

    if (name === 'agriculturalSchoolFaculty' && value === '1') {

      newExtra4['needParkingInMunicipalPardesHannaKarkur'] = '0';
      newExtra4['collectionOrWaterDepartmentEmployees'] = '0';
      newExtra4['kindergartenElaAndAgosEmployees'] = '0';
      newExtra4['planningAndConstructionCommitteeEmployees'] = '0';

    }

    if (name === 'collectionOrWaterDepartmentEmployees' && value === '1') {

      newExtra4['needParkingInMunicipalPardesHannaKarkur'] = '0';
      newExtra4['agriculturalSchoolFaculty'] = '0';
      newExtra4['kindergartenElaAndAgosEmployees'] = '0';
      newExtra4['planningAndConstructionCommitteeEmployees'] = '0';
    }

    if (name === 'kindergartenElaAndAgosEmployees' && value === '1') {

      newExtra4['needParkingInMunicipalPardesHannaKarkur'] = '0';
      newExtra4['agriculturalSchoolFaculty'] = '0';
      newExtra4['planningAndConstructionCommitteeEmployees'] = '0';
      newExtra4['collectionOrWaterDepartmentEmployees'] = '0';
    }

    if (name === 'planningAndConstructionCommitteeEmployees' && value === '1') {

      newExtra4['needParkingInMunicipalPardesHannaKarkur'] = '0';
      newExtra4['agriculturalSchoolFaculty'] = '0';
      newExtra4['kindergartenElaAndAgosEmployees'] = '0';
      newExtra4['collectionOrWaterDepartmentEmployees'] = '0';
    }


    if (name === 'needParkingInMunicipalPardesHannaKarkur' && value === '1') {

      newExtra4['collectionOrWaterDepartmentEmployees'] = '0';
      newExtra4['agriculturalSchoolFaculty'] = '0';
      newExtra4['kindergartenElaAndAgosEmployees'] = '0';
      newExtra4['planningAndConstructionCommitteeEmployees'] = '0';
    }

    if (newExtra4.isCityResident === '1' && newExtra4.needParkingInMunicipalPardesHannaKarkur === '1') {

      setFieldValue('contactDetails.house', '1');
      setFieldValue('contactDetails.appartment', '1');
      handleOnChangeStreet(streetId);
      sethouseAndAppDes(true);
      setStreetDes(false);
    } else if (newExtra4.collectionOrWaterDepartmentEmployees === '1'
      || newExtra4.agriculturalSchoolFaculty === '1'
      || newExtra4.needParkingInMunicipalPardesHannaKarkur === '1'
      || newExtra4.planningAndConstructionCommitteeEmployees === '1'
      || newExtra4.kindergartenElaAndAgosEmployees === '1'
      || newExtra4.isCityResident === '0'
    ) {

      if (newExtra4.needParkingInMunicipalPardesHannaKarkur === '1' && newExtra4.isCityResident === '0') {

        streetId = '9002';
      }

      if (newExtra4.collectionOrWaterDepartmentEmployees === '1' && newExtra4.isCityResident === '0') {

        streetId = '9009';
      }

      if (newExtra4.collectionOrWaterDepartmentEmployees === '1' && newExtra4.isCityResident === '1') {

        streetId = '9008';
      }

      if (newExtra4.planningAndConstructionCommitteeEmployees === '1' && newExtra4.isCityResident === '0') {

        streetId = '9011';
      }

      if (newExtra4.planningAndConstructionCommitteeEmployees === '1' && newExtra4.isCityResident === '1') {

        streetId = '9010';
      }

      if (newExtra4.kindergartenElaAndAgosEmployees === '1' && newExtra4.isCityResident === '0') {

        streetId = '9013';
      }

      if (newExtra4.kindergartenElaAndAgosEmployees === '1' && newExtra4.isCityResident === '1') {

        streetId = '9012';
      }

      if (newExtra4.agriculturalSchoolFaculty === '1' && newExtra4.isCityResident === '0') {

        streetId = '9007';
      }

      if (newExtra4.agriculturalSchoolFaculty === '1' && newExtra4.isCityResident === '1') {

        streetId = '9006';
      }

      sethouseAndAppDes(true);
      setStreetDes(true);
      setFieldValue('contactDetails.house', '1');
      setFieldValue('contactDetails.appartment', '1');
      handleOnChangeStreet(streetId);
    } else {

      sethouseAndAppDes(false);
      setStreetDes(false);
      setFieldValue('contactDetails.house', '');
      setFieldValue('contactDetails.appartment', '');
      handleOnChangeStreet('-1');
    }

    setFieldValue('extra4', { ...newExtra4 });

    const res = await getStreetsApi(newExtra4);

    if (res.isSuccess) {

      setStreets(res.streets);
    }

  }

  function determinePermitType(newExtra4: IExtra4Map) {

    const isResident = newExtra4.isCityResident;
    return isResident === '1' ? PermitType.REGULAR : PermitType.NONE_RESIDENT;
  }

}


export default CheckBoxesForPardesHannaKarkur;


